import { render, staticRenderFns } from "./StandaloneDocumentViewer.vue?vue&type=template&id=a3d2972e&scoped=true"
import script from "./StandaloneDocumentViewer.vue?vue&type=script&lang=js"
export * from "./StandaloneDocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./StandaloneDocumentViewer.vue?vue&type=style&index=0&id=a3d2972e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d2972e",
  null
  
)

export default component.exports